import { lazy } from 'react';

import { LandingPaths } from 'Feature/Common/Common/Constant/LandingPaths';
import IRoute from 'Shared/Routes/Models/IRoute';

const MainPage = lazy(() => import('Feature/Common/Main/MainPage'));
const CartItemsPage = lazy(() => import('Feature/Orders/CartItems/Pages/CartItemsPage'));
const PaymentResultPage = lazy(() => import('Feature/Orders/PaymentResult/Pages/PaymentResultPage'));
const NotFoundPage = lazy(() => import('Feature/Common/NotFound/NotFoundPage'));
const MenuPage = lazy(() => import('Feature/Common/Menu/MenuPage'));
const OrderHistoryWithElhaghiehPage = lazy(
  () => import('Feature/Orders/OrderHistoryWithElhaghieh/Pages/OrderHistoryWithElhaghiehPage')
);
const OrderDetailPage = lazy(() => import('Feature/Orders/OrderDetail/Pages/OrderDetailPage'));
const ContentPage = lazy(() => import('Feature/Common/Contents/ContentPage'));
const SabtElhaghiyehPage = lazy(() => import('Feature/Common/SabtElhaghiyeh/SabtElhaghiyehPage'));

const LandingRoute: IRoute[] = [
  {
    path: '*',
    component: NotFoundPage,
    needAuth: false,
  },
  {
    path: LandingPaths.Landing.Main,
    component: MainPage,
    needAuth: true,
  },
  {
    path: LandingPaths.Landing.Menu,
    component: MenuPage,
    needAuth: true,
  },
  {
    path: LandingPaths.Landing.PaymentResult,
    component: PaymentResultPage,
    needAuth: true,
    parameters: ['orderId', 'paymentId'],
  },
  {
    path: LandingPaths.Landing.PaymentResult,
    component: PaymentResultPage,
    needAuth: true,
  },
  {
    path: LandingPaths.Landing.Cart,
    component: CartItemsPage,
    needAuth: true,
  },
  {
    path: LandingPaths.Landing.Cart,
    component: CartItemsPage,
    needAuth: true,
    parameters: ['orderId'],
  },
  {
    path: LandingPaths.Landing.OrderHistoryOrElhaghieh,
    component: OrderHistoryWithElhaghiehPage,
    needAuth: true,
    parameters: ['listType'],
  },
  {
    path: LandingPaths.Landing.OrderDetail,
    component: OrderDetailPage,
    needAuth: true,
    parameters: ['orderId'],
  },
  {
    path: LandingPaths.Landing.Contents,
    component: ContentPage,
    needAuth: true,
    parameters: ['id'],
  },
  {
    path: LandingPaths.Landing.SabtElhaghiyeh,
    component: SabtElhaghiyehPage,
    needAuth: true,
  },
];

export default LandingRoute;
